import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

export const LocationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: ${({ expanded }) => (expanded ? 1 : 0)};
  height: ${({ expanded }) => (expanded ? '100%' : 'auto')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
`;

export const HistoricWrapper = styled(Box).attrs({
  color: 'primaryText',
  bg: 'background',
  transition: '0.5s',
})`
  width: 100%;
  border-top: ${({ expanded, theme }) =>
    expanded ? `1px solid ${theme.colors.lightLineDivider}` : 0};
  height: ${({ expanded }) => (expanded ? '100%' : 0)};
  overflow: auto;
  padding-bottom: ${({ expanded, showBottomPadding = false }) =>
    expanded && showBottomPadding ? '16px' : expanded ? 0 : '16px'};
`;

export const HistoricWrapperContent = styled.div`
  display: ${({ expanded }) => (expanded ? 'flex' : 'none')};
  flex-flow: ${({ shouldReverse }) =>
    shouldReverse ? 'column-reverse nowrap' : 'column nowrap'};
  height: 100%;
  transition: 0.5s;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  padding: 12px;
  overflow: auto;
  overflow-x: hidden;
  border-top: none;
`;

export const InnerWrapper = styled.div`
  height: 100%;
  border: none;
  overflow: auto;
  overflow-x: hidden;
`;
